import { render, staticRenderFns } from "./BlogTitle.vue?vue&type=template&id=5b8559f8&"
import script from "./BlogTitle.vue?vue&type=script&lang=js&"
export * from "./BlogTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports